import React from 'react';

export const useBoolean = (initialState) => {
    const [value, setValue] = React.useState(initialState);

    return [value, () => setValue(true), () => setValue(false), () => setValue(!value)];
};
